// extracted by mini-css-extract-plugin
export default {"menuWrap":"MobileMypage_menuWrap__N9Lug"};